/**
 * Utility method to determine if any text is currently selected (highlighted) on the window.
 */
export function isAnyTextSelected() {
    const selection = window.getSelection();
    return selection ? selection.type === 'Range' || selection.toString().length > 0 : false;
}
